import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'Music Ready Flashcards Pack',
  description: 'Reinforce every core concept',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c6ff8a03-37bb-49c7-b675-f93828febd94.jpg'
}, {
  title: 'The Music Ready Teacher & Parent Guide',
  description: 'Teach with zero music training',
  price: '$47',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2cb5dcf8-e17e-40f6-baae-63f11b701a97.jpg'
}, {
  title: 'Music Ready Progress Tracker & Certificates',
  description: 'Keep students motivated',
  price: '$27',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/c2590492-d06e-4e11-beaf-4c372d30ac81.jpg'
}, {
  title: 'Music Ready Games & Puzzles Pack',
  description: 'Learning that feels like play',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e2d73159-8848-4d12-addf-7c4d7a920156.jpg'
}, {
  title: 'Music Ready Global Songbook',
  description: 'Songs to perform and apply skills',
  price: '$37',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2452570f-27eb-4003-ae1f-aaac661d7a39.jpg'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="2lvu6m99mdom">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="2kb356m5tcvi">
        <div className="mb-12 text-center" data-id="element-19" data-mp="7l8jddnlzwud">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-20" data-mp="7m0d0ixnbki0">INCLUDED FREE TODAY</div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-21" data-mp="gklvke34azis">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="ld57l6m5pmlh">Valued at <span className="font-bold text-brand-purple line-through" data-id="element-23" data-mp="leg8myo7wg8w">$185 USD</span> — yours at no extra cost today.</p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="vatcgpdh8ahd">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="109e5o4ub9twb" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="alqpwdy1n9v7">{index + 1}</span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="kbk5rr57yb59" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="tbglv4djm1op"><h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="tap1kppebqdq">{bonus.title}</h3><p className="mt-1 text-xs" data-id="element-30" data-mp="ocvu7tccwqbv"><span className="text-brand-gray" data-id="element-31" data-mp="oblw545i7i58">{bonus.description}</span><span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="139wc754qx6x5">value {bonus.price}</span><span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="137jvevaq52lo">FREE</span></p></div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}